import * as React from 'react'
import { ReactElement, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import MessageContext from '../../context/MessageContext'
import { ActionButton, getId, Stack, StackItem } from '@fluentui/react'
import { isOfficeInitialized } from '../../helpers/outlookHelper'
import { useSelector } from 'react-redux'
import { Store } from '../../reducers'

export default function FileLink(): ReactElement {
    const { fileIdMap } = useContext(MessageContext)
    const selectedFileId = useSelector<Store, string>(state => state.files.current.data?.id)
    const history = useHistory()

    if (!isOfficeInitialized() || !fileIdMap) {
        return <></>
    }

    return (
        <Stack horizontal>
            {[...fileIdMap.entries()]
                .filter(([, id]) => selectedFileId !== id)
                .map(([reference, id]) => (
                    <StackItem key={getId()}>
                        <ActionButton
                            onClick={() => {
                                history.push(`/file/${id}`)
                            }}
                            primary={false}
                            iconProps={{ iconName: 'Album' }}
                        >
                            {reference}
                        </ActionButton>
                    </StackItem>
                ))}
        </Stack>
    )
}
